import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { tenantSlugFromPath, applyBrandColor } from "@/lib/tenant";

// Componente invisível que fica dentro do BrowserRouter e observa mudanças
// de rota. Quando o slug do tenant muda (ex: /fazbem/... → /outraempresa/...),
// carrega o branding correto via /api/branding/{slug} e aplica cor + logo.
// Se estamos numa rota sem slug (ex: /login, /admin/empresas), limpa o branding.
// Se o slug não bate com nenhuma empresa (404), redireciona para "/" (Landing).
export function TenantBrandingSync() {
  const { setTenantBranding } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const slug = tenantSlugFromPath(location.pathname);
    if (!slug) {
      setTenantBranding?.(null);
      return;
    }
    let alive = true;
    api.get(`/branding/${slug}`)
      .then((r) => {
        if (!alive) return;
        setTenantBranding?.(r.data);
        applyBrandColor(r.data?.cor_primaria);
      })
      .catch((err) => {
        if (!alive) return;
        setTenantBranding?.(null);
        // 404: slug não existe → volta para Landing (não deixa o usuário preso numa URL inválida)
        if (err?.response?.status === 404) {
          navigate("/", { replace: true });
        }
      });
    return () => { alive = false; };
  }, [location.pathname, setTenantBranding, navigate]);
  return null;
}
